module.exports = __webpack_public_path__ + "img/nl.df8801a0.png";